import { render, staticRenderFns } from "./AscentGymRouteHardnessIcon.vue?vue&type=template&id=3f157108"
import script from "./AscentGymRouteHardnessIcon.vue?vue&type=script&lang=js"
export * from "./AscentGymRouteHardnessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports